import React, { useState } from 'react';
import { BreadCrumb } from '../../common/breadcrumb';
import api from '../../../services/axios';
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import { useJWTAuth } from '../../../services/JWTAuthProvider';
import config from '../../../config';
import { userRole } from '../../../constants/appConst';

export const AddUser = () => {

    const { user } = useJWTAuth();
    const [selectedDropdownItem, setSelectedDropdownItem] = useState('Select Role');
    const [subBtnDisabled, setSubBtnDisabled] = useState(false);
    const [passwordRegexError, setPasswordRegexError] = useState(false);

    const navigate = useNavigate();
    const [showToast] = useState(false);
    const [formValues, setFormValues] = useState({
        name: '',
        id: '',
        password: '',
        confirm: '',
    });
    const [formErrors, setFormErrors] = useState({
        name: '',
        id: '',
        password: '',
        confirm: '',
    });
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [passwordMatchError, setPasswordMatchError] = useState(false);
    const [nameRegexError, setNameRegexError] = useState(false);
    const [roleSelection, setRoleSelection] = useState('');
    const [selectedFolders, setSelectedFolders] = useState([]);
    const [isExxonEmployee, setIsExxonEmployee] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [roleRequiredError, setroleRequiredError] = useState(false);
    const [folderRequiredError, setfolderRequiredError] = useState(false);

    const roleMapping =
    {
        1: "Global Admin",
        2: "Business Unit Admin",
        3: "Business Unit User"
    }

    const [folderList, setFolderList] = React.useState([]);
    React.useEffect(() => {
        const getData = async () => {
            try {
                const { data } = await api.get("/Folders/getrootfolders?Id=" + user.id);
                if (data.statusCode === 200) {
                    setFolderList(data.result.folders);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        getData();
    }, []);

    const handleDropdownItemClick = (number) => {
        /*validateForm();*/
        setSelectedDropdownItem(roleMapping[number]);
        setRoleSelection(number); // Update the selected Role

        setroleRequiredError(false);
        setSelectedFolders([]);
    };
    if (!isExxonEmployee) {

    }

    const breadcrumbItems = [
        { label: 'Home Page', url: '/' },
        { label: 'User Management', url: '/UserManagement' },
        { label: 'Add User', url: '' },
    ];

    const validatePassword = (password) => {
        const isLengthValid = password.length >= 8 && password.length <= 16;
        const hasSpecialCharacter = /[!@#$%^&*()_+{}[\]:;<>,.?~\\-]/.test(password);
        const hasCapitalLetter = /[A-Z]/.test(password);
        const hasLowerLetter = /[a-z]/.test(password);
        return isLengthValid && hasSpecialCharacter && hasCapitalLetter && hasLowerLetter;
    };



    const validateForm = () => {
        const errors = {};
        if (!formValues.name) {
            errors.name = '* Name is required';
        }
        if (!formValues.id) {
            errors.id = '* User ID is required';
        }

        if (formValues.name) {
            const regex = /^[a-zA-Z0-9' ]+$/;

            // Check if the entered username matches the pattern
            const isValid = regex.test(formValues.name);
            if (!isValid) {
                setNameRegexError(true);
                setSubBtnDisabled(false);
                return;
            }
        }


        if (!isExxonEmployee) {
            if (!formValues.password) {
                errors.password = '* Password is required';
            }
            if (!formValues.confirm) {
                errors.confirm = '* Confirm Password is required';
            }
            if (formValues.confirm !== formValues.password) {
                errors.confirm = '* Confirm Password should be same as Password';
            }
            if (config.SSODOMAIN.findIndex((e) => formValues.id.toLowerCase().includes(e)) >= 0) {
                errors.id = '* Please use Non Exxon UserID or Email';
            }

        }

        if (isExxonEmployee) {
            if (config.SSODOMAIN.findIndex((e) => formValues.id.toLowerCase().includes(e)) >= 0) {

            }
            else {
                errors.id = '* Please use Exxon UserID';
            }
        }

        if (!isValidUserID(formValues.id)) {
            errors.id = '* Please enter valid UserID';
        }

        setFormErrors(errors);
        return Object.values(errors).every((error) => error === '');
    };

    const handleInputChange = (fieldName, value) => {
        setFormErrors({ ...formErrors, [fieldName]: '' });

        if (fieldName === 'confirm') {
            setPasswordMatchError(false);
        }

        setFormValues({ ...formValues, [fieldName]: value });
    };

    const handleclose = () => {
        navigate('/UserManagement');
    }

    const isValidUserID = (name) => {
        // Regular expression for email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        // Regular expression for proper name validation
        const nameRegex = /^[a-zA-Z0-9_` ]+$/;

        // Check if the name matches either email or proper name format
        return emailRegex.test(name) || nameRegex.test(name);
    }

    // Example email validation function
    const isValidEmail = (email) => {
        // Add your email validation logic here
        // Return true if the email is valid, false otherwise
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const handleSubmit = async (e) => {
        setSubBtnDisabled(true)
        e.preventDefault();
        setIsFormSubmitted(true);
        if (roleSelection === "") {
            setroleRequiredError(true);
            setSubBtnDisabled(false);
        }
        var isSSOLogin = '';
        if (validateForm()) {
            var password = ''
            if (isExxonEmployee) {
                password = '';
                isSSOLogin = true;
                formValues.password = '';
                formValues.confirm = '';
            }
            else {
                password = formValues.password;
                if (!validatePassword(password)) {
                    setPasswordRegexError(true);
                    setSubBtnDisabled(false);
                    return;
                }
                isSSOLogin = false;
            }

            if (formValues.id) {
                //const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                //const isValid = emailRegex.test(formValues.id);
                //if (!isValid) {
                //    setEmailRegerError(true);
                //    setSubBtnDisabled(false);
                //    return;
                //}
            }

            if (roleSelection !== 1 && selectedFolders.length === 0) {
                setfolderRequiredError(true);
                setSubBtnDisabled(false);
                return;
            }
            if (roleSelection === 1) {
                CheckAll();
            }

            try {
                const { data } = await api.post("/UserCreation/CreateUser", {
                    name: formValues.name,
                    userid: formValues.id,
                    password: password,
                    email: isValidEmail(formValues.id) ? formValues.id : '',
                    role: roleSelection,
                    isssologin: isSSOLogin,
                    folders: selectedFolders,
                    rowvalue: 0
                });
                if (data.statusCode === 200) {
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        text: "User created successfully",
                        confirmButtonText: "Ok",
                        timer: 2000,
                        timerProgressBar: true,
                    }).then(val => {
                        if (val) {
                            navigate('/UserManagement');
                        }
                    });
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        setSubBtnDisabled(false)
    };

    const handleFolderSelection = (folder) => {
        setfolderRequiredError(false);
        // Add or remove the selected folder from the array
        setSelectedFolders((prevSelected) => {
            if (prevSelected.includes(folder)) {
                return prevSelected.filter((item) => item !== folder);
            } else {
                return [...prevSelected, folder];
            }
        });
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleNonExxonChange = () => {
        setFormErrors('');
        setIsExxonEmployee(false)
        setPasswordRegexError(false);
        setPasswordMatchError(false);
        setNameRegexError(false);
        setroleRequiredError(false);
    }

    const handleExxonChange = () => {
        setFormErrors('');
        setIsExxonEmployee(true);
        setPasswordRegexError(false);
        setPasswordMatchError(false);
        setNameRegexError(false);
        setroleRequiredError(false);
        formValues.password = '';
        formValues.confirm = '';
    }

    const CheckAll = () => {
        if (selectedFolders.length === 0 && selectedFolders.length < folderList.length) {
            return true;
        }
        else if (selectedFolders.length < folderList.length) {
            return true;
        }
        else {
            return false;
        }
    }


    const handleSelectAllFolders = (e) => {
        setfolderRequiredError(false);
        if (e.target.checked) {
            // Select all folders
            setSelectedFolders(folderList.map(li => li.folderIdentifier));
        } else {
            // Deselect all folders
            setSelectedFolders([]);
        }
    };
    return (
        <>
            <div className='right-content'>

                <BreadCrumb items={breadcrumbItems}></BreadCrumb>

                <div className='mid-box-wrap'>
                    <h4 className='sub-head'>Add User</h4>
                    <form className='add-form' onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className='col-md-6 add-user-label'>
                                <div class="mb-2">
                                    <label for="name" class="form-label">Name</label>
                                    <input
                                        type="text"
                                        className={`form-control ${formErrors.name && 'error'}`}
                                        id="name"
                                        placeholder="Enter name"
                                        value={formValues.name}
                                        maxLength="200"
                                        onChange={(e) => {
                                            handleInputChange('name', e.target.value);
                                            setPasswordRegexError(false);
                                            setPasswordMatchError(false);
                                            setNameRegexError(false);
                                        }}
                                    />
                                    {isFormSubmitted && formErrors.name && (
                                        <p className="error-message">{formErrors.name}</p>
                                    )}
                                    {nameRegexError && (
                                        <p className="error-message">* Name should be in valid format</p>
                                    )}
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="exxonMobilEmployee"
                                        id="nonExxon"
                                        checked={!isExxonEmployee}
                                        onClick={() => handleNonExxonChange()}
                                    />
                                    <label className="form-check-label" for="nonExxon">
                                        Non-ExxonMobil Employee
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="exxonMobilEmployee"
                                        id="exxonEmp"
                                        checked={isExxonEmployee}
                                        onClick={() => handleExxonChange()}
                                    />
                                    <label className="form-check-label" for="exxonEmp">
                                        ExxonMobil Employee
                                    </label>
                                </div>
                                <div class="mb-2">
                                    <label for="id" class="form-label">User Id</label>
                                    <input
                                        type="text"
                                        className={`form-control ${formErrors.id && 'error'}`}
                                        id="id"
                                        maxLength="100"
                                        placeholder="Enter User ID"
                                        value={formValues.id}
                                        onChange={(e) => {
                                            handleInputChange('id', e.target.value);
                                            setPasswordRegexError(false);
                                            setPasswordMatchError(false);
                                        }}
                                    />
                                    {isFormSubmitted && formErrors.id && (
                                        <p className="error-message">{formErrors.id}</p>
                                    )}
                                </div>

                                <div className={`mb-2 ${isExxonEmployee ? 'add-opacity' : ''}`}>
                                    <label for="password" class="form-label">Password</label>
                                    <div className='input-wrap'>      <input
                                        type={showPassword ? 'text' : 'password'}
                                        className={`form-control ${formErrors.password && 'error'}`}
                                        id="password"
                                        placeholder="Enter Password"
                                        value={formValues.password}
                                        onChange={(e) => {
                                            handleInputChange('password', e.target.value);
                                            setPasswordRegexError(false);
                                            setPasswordMatchError(false);
                                        }}
                                        disabled={isExxonEmployee}
                                    />

                                        <div className={`input-img ${showPassword ? 'show-pass' : 'hide-pass'}`} onClick={togglePasswordVisibility}>
                                        </div></div>

                                    {isFormSubmitted && formErrors.password && (<p className="error-message">{formErrors.password}</p>
                                    )}
                                    {passwordMatchError && (
                                        <p className="error-message">* Confirm Password does not match the Password</p>
                                    )}
                                    {passwordRegexError && <p className='error-message'> * Password must be 8 - 16 characters and have at least one capital letter, small letter and special character(! @#$ % ^ & *?.) </p>}

                                </div>
                                <div className={`mb-2 ${isExxonEmployee ? 'add-opacity' : ''}`}>
                                    <label for="confirm" class="form-label">Confirm Password</label>
                                    <div className='input-wrap'> <input
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        className={`form-control ${formErrors.confirm && 'error'}`}
                                        id="confirm"
                                        placeholder="Enter Confirm Password"
                                        value={formValues.confirm}
                                        onChange={(e) => handleInputChange('confirm', e.target.value)}
                                        disabled={isExxonEmployee}
                                    />
                                        <div className={`input-img ${showConfirmPassword ? 'show-pass' : 'hide-pass'}`} onClick={toggleConfirmPasswordVisibility}>
                                        </div></div>
                                    {isFormSubmitted && formErrors.confirm && (
                                        <p className="error-message">{formErrors.confirm}</p>
                                    )}
                                </div>

                            </div>
                            <div className='col-md-6 add-user-label'>
                                <div class="mb-2">
                                    <label for="dropdownMenuButton1" class="form-label">Role</label>
                                    <div className="dropdown">
                                        <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                            {selectedDropdownItem}
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            {user.role === userRole.BusinessUnitAdmin ? null :
                                                <li onClick={() => handleDropdownItemClick(1)}><span className="dropdown-item">Global Admin</span></li>
                                            }
                                            <li onClick={() => handleDropdownItemClick(2)}><span className="dropdown-item">Business Unit Admin</span></li>
                                            <li onClick={() => handleDropdownItemClick(3)}><span className="dropdown-item">Business Unit User</span></li>
                                        </ul>
                                    </div>
                                    {isFormSubmitted}
                                    {roleRequiredError && (
                                        <p className="error-message">* Please select at least one role</p>
                                    )}
                                </div>
                                <div className={`mb-2 ${roleSelection === 1 ? 'role-show' : ''}`}>
                                    <label class="form-label">Select Folder</label>
                                    <div className='select-folder'>
                                        <div className='folder-check-wrap'>
                                            <div className='all-check'>
                                                <input type="checkbox" id='all' onChange={handleSelectAllFolders} checked={CheckAll() ? false : true} disabled={roleSelection === 1} /> <label for="all">Select All Folders</label>
                                            </div>
                                            {folderList.map((folder) => (

                                                <div className='single-check'>
                                                    <input type="checkbox" id={folder.folderIdentifier} checked={selectedFolders.includes(folder.folderIdentifier)} onChange={() => handleFolderSelection(folder.folderIdentifier)} /> <label for={folder.name} ><img src="../Assets/folder-icon.svg" alt='User' /> {folder.name}</label>
                                                </div>
                                            ))}

                                        </div>
                                    </div>
                                    {folderRequiredError && (
                                        <p className="error-message">* Please select at least one folder</p>
                                    )}

                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={handleclose}>
                                Cancel
                            </button>
                            <button disabled={subBtnDisabled} className='btn btn-primary' type='submit'>Submit</button>
                        </div>
                    </form>
                    <div className={`toast-message ${showToast ? 'active' : ''}`}>
                        User Created Successfully. <span className='close-btn' >X</span>
                    </div>
                </div>
            </div>
        </>
    )
}
